import { useMutation } from '@tanstack/react-query';
import { signInMutationFunction } from '@/modules/Auth/queries/signIn/signInMutationFunction.ts';

const useSignInRequest = () => {
  return useMutation({
    mutationFn: signInMutationFunction,
    meta: {
      error: false,
    },
  });
};

export default useSignInRequest;
